// UI strings for the week's letter (2026-10-13): the partner's letter that opens once you have written
// yours (letters/WeekLetters.tsx LockedLetter), the letter on Tänään, the week's letters in the lesson's Kirje step and
// on Oppitunnit, and the stress marks under the text while writing (letters/StressRow.tsx).
// Finnish is written in full and never truncated; en must have exactly the same shape.
import { defineArea } from '../area';

export const letterGateFi = {
  /** The locked card's heading: the partner wrote the week's letter. */
  lockedH: (name: string) => `${name} on kirjoittanut tämän viikon kirjeen`,
  lockedP: 'Kirjoita oma kirjeesi, niin näet hänen kirjeensä.',
  /** Your own letter is still waiting to be sent. */
  lockedSending: 'Kirjeesi lähtee, kun yhteys palaa. Sen jälkeen näet hänen kirjeensä.',
  /** A locked letter in a list, in place of its first line. */
  lockedRow: 'Aukeaa, kun kirjoitat omasi',
  open: 'Avaa kirje',
  /** The lesson's Kirje step and Oppitunnit: the letters of one week. */
  weekH: 'Viikon kirjeet',
  partnerNone: (name: string) => `${name} ei ole vielä kirjoittanut.`,
  /** Oppitunnit: the letters grouped by lesson (folded, like Läpäistyt). */
  byLessonH: (n: number) => `Kirjeet ${n}`,

  // ---- stress marks while writing ----
  stressH: 'Painolliset tavut',
  stressHint: 'Napauta jokaisen sanan painollista tavua.',
  stressNone: 'Yksitavuisiin sanoihin ei merkitä painoa.',
  /** A syllable button's name for screen readers. */
  stressTap: (syllable: string, word: string) => `${syllable}, sanassa ${word}`,
  stressAgree: 'Merkintäsi noudattavat painosääntöä.',
  stressDiffer: 'Säännön mukaan paino on muualla:',
  /** The reader: what the small mark before a syllable means. */
  stressLegend: 'ˈ tavun edessä: kirjoittaja merkitsi sen painolliseksi.',
};

export const letterGateEn: typeof letterGateFi = {
  lockedH: (name) => `${name} has written this week’s letter`,
  lockedP: 'Write your own letter to read theirs.',
  lockedSending: 'Your letter sends when you are back online. Then you can read theirs.',
  lockedRow: 'Opens when you write yours',
  open: 'Open the letter',
  weekH: 'This week’s letters',
  partnerNone: (name) => `${name} has not written yet.`,
  byLessonH: (n) => `Letters ${n}`,
  stressH: 'Stressed syllables',
  stressHint: 'Tap the stressed syllable of each word.',
  stressNone: 'One-syllable words take no stress mark.',
  stressTap: (syllable, word) => `${syllable}, in ${word}`,
  stressAgree: 'Your marks follow the stress rule.',
  stressDiffer: 'The rule puts the stress elsewhere:',
  stressLegend: 'ˈ before a syllable: the writer marked it stressed.',
};

// Messages.letterGate (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('letterGate', letterGateFi, letterGateEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof letterGateFi> {}
}
